<template>
  <div class="publicMain" v-loading="homeLoading">
    <div class="leftClass" :style="leftStyle">
      <!-- 分页左侧按钮 -->
      <div class="leftPage positionPage">
        <div class="leftBtn positionBtn el-icon-arrow-left" :class="isPrevClick?'':'activeDisabled'"
          @click="paginationClick('prev')"></div>
      </div>
      <div class="BIHome">
        <el-container>
          <!-- 主内容部分 -->
          <el-main>
            <!-- 搜索 -->
            <div class="search"></div>
            <!-- 看板内容 -->
            <div class="KanBan">
              <!-- 看板列表 -->
              <div class="kanBanList">
                <!-- 单个看板（新增） -->
                <!-- <div class="kanBanItem newKanBan" @click="createKanBan" v-if="currentPage <= pageSize"> -->
                <div class="kanBanItem newKanBan" @click="createKanBan">
                  <div class="card">
                    <!-- 遮罩 -->
                    <div class="card-highlight-mask">
                      <div class="card-highlight-corner-top-left"></div>
                      <div class="card-highlight-corner-top-right"></div>
                      <div class="card-highlight-corner-bottom-left"></div>
                      <div class="card-highlight-corner-bottom-right"></div>
                    </div>
                    <!-- 内容 -->
                    <div class="card-contant">
                      <div class="create-display">
                        <i class="el-icon-circle-plus-outline"></i>
                        <div>新建看板</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 单个看板（查看编辑） -->
                <div class="kanBanItem viewKanBan" v-for="(item, index) in kanBanArr" :key="index">
                  <div class="card" style="">
                    <!-- 遮罩 -->
                    <div class="card-highlight-mask">
                      <div class="card-highlight-corner-top-left"></div>
                      <div class="card-highlight-corner-top-right"></div>
                      <div class="card-highlight-corner-bottom-left"></div>
                      <div class="card-highlight-corner-bottom-right"></div>
                    </div>
                    <div class="card-selection-mask" :class="{mask:maskShow}" @click.stop="cancelMask"></div>
                    <!-- 内容 -->
                    <div class="card-contant" style="border: solid 1px rgba(26, 115, 232, 0.3); position: relative;"
                      @click="editKanBan(item)">
                      <img :src="item.thumbnail" alt="" v-if="item.thumbnail" style="top: 0; left: 0; width: 100%; height: 100%; position: absolute;" />
                      <!-- hover样式 -->
                      <div class="card-hover-mask">
                        <!-- 复选框 -->
                        <div class="multi-select-kanban"></div>
                        <!-- hover内容 -->
                        <div class="card-hover-layout">
                          <div class="card-hover-text" @click.stop="editKanBan(item)">点击编辑</div>
                          <div class="card-hover-buttons">
                            <div class="el-icon-s-promotion" title="发布" @click.stop="releaseKanBan(item)"></div>
                            <div class="el-icon-share" title="分享" @click.stop="shareKanBan(item)"></div>
                            <div class="el-icon-document-copy" title="复制" @click.stop="copyKanBan(item)"></div>
                            <div class="el-icon-delete" title="删除" @click.stop="delKanBan(item)"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 内容底部 -->
                    <div class="card-footer" title="点击修改名称">
                      <div class="card-footer-content">
                        <div class="rename-input-container" @click.stop="clickKanBanName(item, index, $event)">
                            <el-input v-model="item.mbmc" :ref="'focusRef' + index" v-if="selectIndex == index"
                              @keyup.enter.native="selectIndex = null" @blur="editKanBanName(item, index, $event)"></el-input>
                            <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 180px;">
                              <span v-if="selectIndex != index" :title="item.mbmc">{{ item.mbmc }}</span>
                            </div>
                            <div style="padding: 0 5px;">
                              <i v-if="selectIndex != index" class="el-icon-edit"></i>
                            </div>
                            <div style="width: 75px; text-align: right; position: absolute; right: 10px;">
                              <span v-if="selectIndex != index">{{ $comUtils.dateFormat("yyyy-MM-dd", new Date(item.updateAt)) }}</span>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-main>
        </el-container>
      </div>
      <!-- 分页右侧按钮 -->
      <div class="rightPage positionPage">
        <div class="rightBtn positionBtn el-icon-arrow-right" :class="isNextClick?'':'activeDisabled'"
          @click="paginationClick('next')"></div>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" top="10vh" class="shareClass"
      :close-on-click-modal="false" :close-on-press-escape="true" @close="handleClose">
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
            <!-- "el-icon-document-add" -->
          </span>
        </i>
      </label>
      <el-card>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" :validate-on-rule-change="false"
          size="small">
          <el-row>
            <el-col :span="12">
              <el-form-item :label="'父权限ID'" prop="pid" class="formClass">
                <el-input disabled v-model="ruleForm.pid"></el-input>
              </el-form-item>
              <el-form-item :label="'权限ID'" prop="qid">
                <el-input disabled v-model="ruleForm.qid"></el-input>
              </el-form-item>
              <el-form-item :label="'权限中文名'" prop="titleZh">
                <el-input v-model="ruleForm.titleZh"></el-input>
              </el-form-item>
              <el-form-item :label="'权限英文名'" prop="titleEn">
                <el-input v-model="ruleForm.titleEn"></el-input>
              </el-form-item>
              <el-form-item :label="'权重'" prop="weight">
                <el-input v-model="ruleForm.weight"></el-input>
              </el-form-item>
              <el-form-item :label="'路径'" prop="path">
                <el-input v-model="ruleForm.path"></el-input>
              </el-form-item>
              <el-form-item :label="'路由名称'" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item :label="'重定向路径'" prop="redirect">
                <el-input v-model="ruleForm.redirect"></el-input>
              </el-form-item>
              <el-form-item :label="'组件'" prop="component">
                <el-input v-model="ruleForm.component"></el-input>
              </el-form-item>
              <el-form-item :label="'权限图标'" prop="icon">
                <el-input v-model="ruleForm.icon"></el-input>
              </el-form-item>
              <el-form-item :label="'是否显示'" prop="isHide" class="isHideClass">
                <el-radio-group v-model="ruleForm.isHide">
                  <el-radio label="1">{{ this.$i18n.locale == 'zh' ? '是' : 'yes' }}</el-radio>
                  <el-radio label="0">{{ this.$i18n.locale == 'zh' ? '否' : 'no' }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item :label="$t('qxgl.catalog')" prop="catalog" style="text-align: left">
                <el-radio-group v-model="ruleForm.catalog" disabled>
                  <el-radio label="1">{{ this.$i18n.locale == 'zh' ? '是' : 'yes' }}</el-radio>
                  <el-radio label="0">{{ this.$i18n.locale == 'zh' ? '否' : 'no' }}</el-radio>
                </el-radio-group>
              </el-form-item> -->
            </el-col>
            <el-col :offset="2" :span="10" style="font-size: 14px;">
              <el-row style="text-align: left;">
                <span style="font-weight: bold;">{{ '请选择目录节点' }}</span>
                <el-tree :data="treeData" ref="qxTree" node-key="qid" :style="treeStyle" :props="treeDefaultProps"
                  :expand-on-click-node="false" accordion @node-click="handleNodeClick" :default-expanded-keys="['X']">
                </el-tree>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">{{ '取消' }}</el-button>
        <el-button type="primary" size="small" @click="submitForm('ruleForm', 'release')">{{ '保存' }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogTitle" :visible.sync="shareDialogFormVisible" top="10%" class="shareClass"
      :close-on-click-modal="false" :close-on-press-escape="true" @close="shareHandleClose">
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
            <!-- "el-icon-document-add" -->
          </span>
        </i>
      </label>
      <el-card>
        <el-form :model="shareRuleForm" :rules="shareRules" ref="shareRuleForm" label-width="100px"
          :validate-on-rule-change="false" size="small">
          <el-col :span="24">
            <el-row>
              <el-col :span="13" class="linkClass">
                <el-form-item :label="'模板名称'" prop="mbmc" class="formClass">
                  <el-input disabled v-model="shareRuleForm.mbmc"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="14">
                <el-form-item :label="'有效期至'" prop="yxqz">
                  <el-select v-model="shareRuleForm.effectiveVal" default-first-option clearable style="width: 35%;" @change="timeChange">
                    <el-option v-for="item in optionsEffectiveTime" :key="item.label" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                  <el-input style="width: 5%; visibility: hidden;"></el-input>
                  <el-input disabled v-model="shareRuleForm.yxqz" style="width: 60%;"></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="11">
                <el-form-item :label="'有效期至'" prop="yxqz">
                  <el-date-picker v-model="shareRuleForm.yxqz" type="date" placeholder="选择日期" align="right"
                    :picker-options="dateOptions" value-format="yyyy-MM-dd" @change="timeChange" style="width: 100%">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 4px;" class="linkClass">
              <el-form-item :label="'访问链接'" prop="fwlj">
                <el-input disabled v-model="shareRuleForm.fwlj"></el-input>
              </el-form-item>
            </el-row>
          </el-col>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="shareDialogFormVisible = false">{{ '取消' }}</el-button>
        <el-button type="primary" size="small" @click="submitForm('shareRuleForm', 'share')">{{ '保存' }}</el-button>
      </div>
    </el-dialog>
    <button ref="copyBtn" type="button" style="display: none" v-clipboard:copy="shareRuleForm.fwlj" v-clipboard:success="onCopy"
      v-clipboard:error="onError"></button>
  </div>
</template>

<script>
const pinyin = require("pinyin");
export default {
  name: "biHome",
  data () {
    return {
      switchData: [
        { title: '我的看板' },
        { title: '我的数据' },
        { title: '优秀案例' },
      ],
      mainTab: 1,
      kanBanName: '模板应用', // 看板名称默认值
      editNameFlag: false, // 编辑看板名称开关
      selectIndex: null, // 选中的当前索引
      maskShow: false, // 编辑名称，触发遮罩

      kanBanArr: [],
      // 分页
      currentPage: 0,  // 当前页数
      pageSize: 11, // 每页显示个数
      total: null, // 数据总条数
      // isPrevClick: true, // 分页时是否可以点击
      // isNextClick: true, 

      homeLoading: false,
      screenHeight: '0',
      dialogFormVisible: false,    // 发布模板模态框
      shareDialogFormVisible: false,    // 分享模板模态框
      dialogTitle: '',    // 模态框标题
      ruleForm: {         // 模态框数据
        pid: "",          // 父权限ID
        qid: "",          // 权限ID
        weight: "",       // 权重
        path: "",         // 路径
        name: "",         // 权限名称
        redirect: "",     // 权限重定向
        component: "",    // 权限组件
        titleZh: "",      // 权限中文名称
        titleEn: "",      // 权限英文名称
        icon: "",         // 权限图标
        isHide: "1",      // 菜单显隐状态
        catalog: "",      // 菜单是否为目录
      },
      shareRuleForm: {
        mbmc: "",    // 模板名称
        mbbh: "",    // 模板ID
        yxqz: "",    // 有效期至
        fwlj: "",    // 访问链接
        lsyh: "",    // 临时用户
      },
      optionsEffectiveTime: [{
        value: '1',
        label: '半年'
      }, {
        value: '2',
        label: '一年'
      }, {
        value: '3',
        label: '三年'
      }],
      dialogTitleIcon: '',    // 模态框标题图标
      treeData: [],    // 权限树数据
    }
  },
  // 自定义取消点击的指令
  directives: {
    clickOutSide: {  // 初始化指令
      bind (el, binding, vnode) {
        function documentHandler (e) {
          // 这里判断点击的元素是否是本身，是本身，则返回
          if (el.contains(e.target)) {
            return false;
          }
          // 判断指令中是否绑定了函数
          if (binding.expression) {
            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
            binding.value(e);
          }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener('click', documentHandler);
      },
      update () { },
      unbind (el, binding) {
        // 解除事件监听
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      },
    }
  },
  computed: {
    rules () {    // 模态框数据校验规则
      return {
        pid: [{ required: true, message: '父权限ID不能为空', trigger: ['blur', 'change'] }],
        qid: [{ required: true, message: '权限ID不能为空', trigger: ['blur', 'change'] }],
        titleZh: [{ type: 'string', required: true, message: '请输入权限中文名', trigger: ['blur', 'change'] }],
        titleEn: [{ required: true, message: '请输入权限英文名', trigger: ['blur', 'change'] }],
        weight: [{ required: true, message: '请输入权重', trigger: ['blur', 'change'] }],
        path: [{ required: true, message: '请输入路径', trigger: ['blur', 'change'] }],
        name: [{ required: true, message: '请输入路由名称', trigger: ['blur', 'change'] }],
        component: [{ required: true, message: '请输入组件', trigger: ['blur', 'change'] }],
        icon: [{ required: true, message: '请输入权限图标', trigger: ['blur', 'change'] }],
        // isHide: [
        //   { required: true, message: this.$t('qxgl.ruleIsHide'), trigger: 'blur' }
        // ],
        // catalog: [
        //   { required: true, message: this.$t('qxgl.ruleIsCatalog'), trigger: 'blur' }
        // ],
      }
    },
    shareRules () {
      return {
        mbmc: [{ required: true, message: '模板名称不能为空', trigger: ['blur', 'change'] }],
        fwlj: [{ required: true, message: '访问链接不能为空', trigger: ['blur'] }],
        // effectiveVal: [{ required: true, message: '请选择有效时间', trigger: ['blur', 'change'] }],
        yxqz: [{ required: true, message: '请选择有效时间', trigger: ['blur'] }],
      }
    },
    dateOptions () {
      return {
        // shortcuts: [{
        //   text: this.$t('datePikerBox.today'),
        //   onClick(picker) {
        //     picker.$emit('pick', new Date());
        //   }
        // }, {
        //   text: this.$t('datePikerBox.yesterday'),
        //   onClick(picker) {
        //     const date = new Date();
        //     date.setTime(date.getTime() - 3600 * 1000 * 24);
        //     picker.$emit('pick', date);
        //   }
        // }, {
        //   text: this.$t('datePikerBox.aWeekAgo'),
        //   onClick(picker) {
        //     const date = new Date();
        //     date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
        //     picker.$emit('pick', date);
        //   }
        // }],
        disabledDate (time) {
          return time.getTime() < Date.now();
        },
      }
    },

    treeDefaultProps () {    // 默认权限数据节点绑定数据
      return {
        label: this.$i18n.locale == 'zh' ? 'titleZh' : 'titleEn',
        children: "children"
      }
    },
    treeStyle () {
      return {
        'height': '433px',
        'overflow-y': 'auto',
        'margin-top': '5px'
      }
    },
    leftStyle () {
      return {
        "height": this.screenHeight - 131 + 'px',
        "overflow": "hidden",
        // "flex-wrap": "wrap"
      }
    },
    // currentTotal () {
    //   return this.currentPage + this.pageSize
    // },
    // 是否可以点上一页
    isPrevClick () {
      if (this.currentPage > 0) {
        return true
      } else {
        return false // 不能点击
      }
    },
    // 是否可以点击下一页
    isNextClick () {
      if (this.currentPage + this.pageSize < this.total) {
        return true
      } else {
        return false // 不能点击
      }
    },
  },
  created () {
    this.getKanBanList(this.currentPage)
  },
  mounted () {
    // 监听浏览器的宽和高
    this.screenHeight = document.body.clientHeight
    window.addEventListener('resize', () => this.screenHeight = window.innerHeight, false)
  },
  methods: {
    switchTab (e) {
      console.log(11111, e)
      this.mainTab = e

    },
    // 获取看板数据列表
    async getKanBanList (start) {
      this.homeLoading = true
      let { data: { data } } = await this.$ajax.post('/api/mbgl/getMblist',
        {
          start: start,
          size: this.pageSize
        })
      this.homeLoading = false
      console.log('resList', data)
      // 更新展示数组
      this.kanBanArr = []
      data.mbxx.forEach(item => {
        this.kanBanArr.push(item)
      });
      // 分页赋值
      this.currentPage = data.fyxx.start
      this.total = data.fyxx.dataCnt
    },

    // 新增看板
    async createKanBan () {
      let UUID = this.$comUtils.generateUUID()
      console.log('UUID', UUID)
      await this.$ajax.post('/api/mbgl/saveMbxx',
        {
          mbid: UUID,
          mbmc: this.kanBanName
        })
      this.$router.push({
        path: './biData',
        component: 'biData',
        query: { id: UUID }
      })
    },

    // 分页next prev
    paginationClick (position) {
      if (position == 'next' && this.currentPage + this.pageSize < this.total) {
        if(!this.isNextClick) {
          return
        }
        this.getKanBanList(this.currentPage + this.pageSize)
      }
      // else {
      //   this.isNextClick = false
      //   this.isPrevClick = true
      //   return
      // }

      if (position == 'prev') {
        if(!this.isPrevClick) {
          return
        }
        this.getKanBanList(this.currentPage - this.pageSize)
      }
      //  else {
      //    this.isNextClick = true
      //   this.isPrevClick = false
      //   return
      //  }
    },
    // 进入编辑页面
    editKanBan (item) {
      this.$router.push({
        path: './biData',
        component: 'biData',
        query: { id: item.mbid, type: 'edit' }
      })

    },
    // 编辑看板名称
    async clickKanBanName (item, i, e) {
      this.selectIndex = i
      this.maskShow = true
      this.$nextTick(() => {
        this.$refs['focusRef'+i][0].$refs.input.focus();
      })
    },
    async editKanBanName (item, i, e) {
      this.selectIndex = null
      this.maskShow = false
      // 获取缓存的yhid
      let yhid = sessionStorage.getItem('userId')
      console.log('editName', item)
      await this.$ajax.post('/api/mbgl/updateMbxx',
        {
          mbid: item.mbid,
          mbmc: item.mbmc,
          yhid: yhid
        })
    },
    // 取消mask
    cancelMask () {
      this.maskShow = false
      // this.editNameFlag = false
      this.selectIndex = null
    },



    handleClose () {
      this.$refs['ruleForm'].resetFields();
    },
    shareHandleClose () {
      this.shareRuleForm.mbmc = ""
      this.shareRuleForm.mbbh = ""
      this.shareRuleForm.yxqz = ""
      this.shareRuleForm.fwlj = ""
      this.$refs['shareRuleForm'].resetFields();
    },
    // 发布模板
    async releaseKanBan (item) {
      await this.selectQx();
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.dialogTitle = '发布模板';
        this.dialogTitleIcon = 'el-icon-s-promotion';
        this.ruleForm.titleZh = item.mbmc;
        let tmpMbmc = pinyin(item.mbmc, { style: pinyin.STYLE_NORMAL });
        this.ruleForm.titleEn = tmpMbmc.join('');
        this.ruleForm.isHide = '1';
        this.ruleForm.catalog = '0';
        this.ruleForm.memo2 = item.mbid;
      })
    },
    // 分享模板
    async shareKanBan (item) {
      let _this = this
      await _this.getFxmbxx(item.mbid);
      _this.shareDialogFormVisible = true;
      await _this.$nextTick(() => {
        _this.dialogTitle = '分享模板';
        _this.dialogTitleIcon = 'el-icon-s-promotion';
        _this.shareRuleForm.mbmc = item.mbmc;
        _this.shareRuleForm.mbbh = item.mbid;
      })
    },
    onCopy(e) {
      this.$message.success('访问链接已复制到剪切板中');
    },
    onError(e) {
      this.$message.error("访问链接复制失败");
    },
    /** 获取共享链接 */
    async getFxmbxx (param) {
      let _this = this;
      _this.shareRuleForm.mbmc = ""
      _this.shareRuleForm.mbbh = ""
      _this.shareRuleForm.yxqz = ""
      _this.shareRuleForm.fwlj = ""
      _this.shareRuleForm.lsyh = ""
      // _this.resultFlg = false
      await _this.$ajax.post("/api/mbgl/getFxmbxx", _this.$qs.stringify({ param: param })).then(res => {
        if (res.data.code == '200') {
          _this.shareRuleForm.fwlj = res.data.data.fwlj
          _this.shareRuleForm.yxqz = res.data.data.yxqz
          _this.shareRuleForm.lsyh = res.data.data.lsyh
        }
      })
    },
    /** 获取共享链接 */
    async getShareLink (param) {
      let _this = this;
      _this.httpLink = '';
      await _this.$ajax.post("/api/mbgl/getShareLink", _this.$qs.stringify({ param: param })).then(res => {
        if (res.data.code == '200') {
          _this.httpLink = res.data.data
        }
      })
    },
    /** 选择有效时间 */
    async timeChange () {
      let _this = this
      // 请求协议
      let protocol = window.location.protocol
      // 地址+端口
      let hostPort = window.location.host
      _this.shareRuleForm.yxqz = _this.shareRuleForm.yxqz + ' 23:59:59'
      if (!_this.shareRuleForm.fwlj || _this.shareRuleForm.fwlj.length == 0) {
        await _this.getShareLink(_this.shareRuleForm.yxqz);
        _this.shareRuleForm.fwlj = protocol + "//" + hostPort + '/mbpz/share?suid=' + _this.httpLink
        _this.shareRuleForm.lsyh = _this.httpLink
      }
    },
    /** 节点被点击时的回调 */
    handleNodeClick (data) {
      let maxQid = '';
      this.ruleForm.path = ''
      this.ruleForm.name = ''
      this.ruleForm.component = ''
      this.ruleForm.icon = ''
      this.ruleForm.pid = data.qid;
      if (data.children.length == 0) {
        if (data.qid == 'X' || data.catalog == '0') {
          this.$message.warning("当前点击节点不是目录");
          return
        }
      } else {
        maxQid = data.children[data.children.length - 1].qid;
        this.ruleForm.qid = data.qid + (parseInt(maxQid.substring(maxQid.length - 3)) + 1).toString().padStart(3, '0');
        this.ruleForm.weight = parseInt(data.children[data.children.length - 1].weight) + 1;
        let tmpMbmc = pinyin(this.ruleForm.titleZh, { style: pinyin.STYLE_FIRST_LETTER });
        if (!data.path) {
          this.ruleForm.path = '/' + tmpMbmc.join("").toLowerCase();
        } else if (data.path == '/') {
          this.ruleForm.path = '/home/' + tmpMbmc.join("").toLowerCase();
        } else {
          this.ruleForm.path = data.path + '/' + tmpMbmc.join("").toLowerCase();
        }
        this.ruleForm.name = tmpMbmc.join("").toLowerCase();
        this.ruleForm.component = 'mbpz/biDataView';
        this.ruleForm.icon = 'secondaryMenu';
      }
    },
    // 查询权限
    async selectQx () {
      let _this = this;
      _this.treeData = [];
      await _this.$ajax.post("/api/getQxTree").then(res => {
        if (res.data.code == '200') {
          // $.extend(true, _this.treeData, res.data.data);
          _this.treeData = res.data.data
        }
      })
    },
    /** 保存模态框数据 */
    submitForm (formName, flg) {
      let _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          if (flg == 'share') {
            _this.saveShare();
          } else if (flg == 'release') {
            _this.releaseMbxx();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /** 发布模板 */
    releaseMbxx () {
      let _this = this;
      _this.$ajax.post('/api/mbgl/releaseMbxx', _this.ruleForm).then((res) => {
        _this.dialogFormVisible = false;
        if (res.data.code == '200') {
          _this.selectQx();
          _this.$message.success('模板信息发布成功');
          _this.$requestUtil.getRouter().then(tmpResult => {
            _this.$comUtils.saveObjArr('menuRouter', tmpResult) // 存储路由到localStorage
            _this.$root.$emit('menuRouter', tmpResult);
          })
        }
      }).catch((error) => {
        _this.dialogFormVisible = false;
      });
    },
    /** 分享模板 */
    saveShare () {
      let _this = this;
      _this.$ajax.post('/api/mbgl/saveShare', _this.shareRuleForm).then((res) => {
        _this.shareDialogFormVisible = false;
        if (res.data.code == '200') {
          // _this.$message.success('模板信息分享成功');
          _this.$refs.copyBtn.click();
        }
      }).catch((error) => {
        _this.shareDialogFormVisible = false;
      });
    },


    // 复制看板
    copyKanBan (item) {
      // 获取缓存的yhid
      let yhid = sessionStorage.getItem('userId')
      this.$prompt('请为新看板应用命名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: item.mbmc + '_的副本',
        // inputPattern: /[\w!#$%&'*+/=?^`{|}~-]+(?:\.[\w!#$%&'*+/=?^`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        // inputErrorMessage: '名称格式不正确'
      }).then(async ({ value }) => {
        let res = await this.$ajax.post('/api/mbgl/copyMbxx',
          {
            mbid: item.mbid,
            mbmc: value,
            yhid: yhid
          })
        // 刷新
        this.getKanBanList(this.currentPage)
        this.$message({
          type: 'success',
          message: '复制成功'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });

    },
    // 删除
    async delKanBan (item) {
      this.$confirm(`确定要删除${item.mbmc}吗?`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        console.log('copyitem', item)
        // return
        let res = await this.$ajax.post('/api/mbgl/delMbxx',
          {
            mbid: item.mbid
          })
        // 刷新页面
        this.getKanBanList(this.currentPage)
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
  },
  deactivated () {
    this.$destroy('biHome')
  },
}
</script>

<style scoped lang='scss'>
.publicMain {
  padding: 0;
  // overflow-y: hidden;
  .leftClass {
    // float: left;
    // position: relative;
    // width: 100%;
    // height: 740px;
    display: flex;
    justify-content: center;
    // align-items: center;
    .BIHome {
      width: 100%;
      // height: 100%;
      // position: absolute;
      // top: 0;
      // left: 0;
      overflow-y: hidden;
      overflow-x: hidden;
      // background-image: url('../../assets/bg.jpg');
      // background-color: #1a1e2a;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      color: rgba($color: #ffffff, $alpha: 0.6) !important;
      font-size: 15px;
      .el-container {
        height: 100%;
        // box-sizing: border-box;
        // 左侧导航栏
        .el-aside {
          // position: relative;
          // width: 100%;
          // height: 100%;
          background-color: #1a1e2a;
          .navList {
            // position: absolute;
            // top: 50px;
            // left: 50px;
            // width: 80%;
            // height: 100%;
            // margin-top: 50px;
            // margin-left: 10px;
            .navListItem {
              // display: inline-block;
              // width: 100%;
              // height: 50px;
              // line-height: 50px;
              color: rgba($color: #ffffff, $alpha: 0.6) !important;
              padding: 0 20px;
              margin: 20px 0;
              cursor: pointer;
              border-left: 3px solid transparent;
              &:hover {
                border-left: 3px solid rgba(26, 115, 232, 0.8);
              }
              &:active {
                border-left: 3px solid rgba(26, 115, 232, 0.8);
              }
            }
          }
        }
        // 主内容
        .el-main {
          width: 100%;
          height: 100%;
          // position: relative;
          // 搜索框
          .search {
            width: 100%;
            height: 50px;
          }
          //    整体看板
          .KanBan {
            // width: 100%;
            // height: 100%;
            display: flex;
            // // justify-content: space-around;
            justify-content: center;
            // align-items: center;
            color: rgba($color: #000000, $alpha: 0.6);

            //    看板列表
            .kanBanList {
              width: 1280px;
              // overflow: auto;
            // flex-wrap: wrap;
            // justify-content: center;
              // display: inline-block;
              // width: 84%;
              // height: 100%;
              // padding: 20px;
              // hover时显示边框
              .card:hover .card-highlight-mask {
                opacity: 1;
                // background: white;
              }
              // hover时显示边框
              .card:hover .card-hover-mask {
                opacity: 0.7;
                background: white;
              }
              // hover时显示图标
              .kanBanItem:hover .card-hover-mask .card-hover-layout {
                opacity: 1;
              }
            }

            //    每一个小看板
            .kanBanItem {
              display: inline-block;
              width: 300px;
              height: 200px;
              position: relative;
              vertical-align: top;
              // background-color: rgba(26, 115, 232, 0.03);
              margin: 10px;
              cursor: pointer;
              //    小看板结构
              .card {
                padding: 0;
                width: 100%;
                height: 100%;
                position: relative;
                border-radius: 3px;
                background: inherit !important;
                color: inherit !important;
                box-shadow: none !important;
                //    小看板遮罩层
                .card-highlight-mask {
                  position: absolute;
                  top: -3px;
                  bottom: -3px;
                  left: -3px;
                  right: -3px;
                  opacity: 0;
                  transition: opacity 280ms cubic-bezier(0.4, 0, 0.2, 1);
                  div {
                    border: solid 1px rgba(48, 125, 218, 0.8);
                    border-radius: 6px;
                    position: absolute;
                    width: 40px;
                    height: 40px;
                  }
                  .card-highlight-corner-top-left {
                    left: 0;
                    top: 0;
                    border-bottom: none;
                    border-right: none;
                  }
                  .card-highlight-corner-top-right {
                    right: 0;
                    top: 0;
                    border-bottom: none;
                    border-left: none;
                  }
                  .card-highlight-corner-bottom-left {
                    left: 0;
                    bottom: 0;
                    border-top: none;
                    border-right: none;
                  }
                  .card-highlight-corner-bottom-right {
                    right: 0;
                    bottom: 0;
                    border-top: none;
                    border-left: none;
                  }
                }
                .card-contant {
                  position: relative;
                  border-radius: 5px;
                  overflow: hidden;
                  width: 100%;
                  height: 86%;
                  margin-bottom: 0;
                  // border-radius: 5px;
                  border-bottom-left-radius: 0;
                  border-bottom-right-radius: 0;
                  box-sizing: border-box;
                  transition: border-color 280ms cubic-bezier(0.4, 0, 0.2, 1),
                    box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
                  // border: solid 1px rgba(26, 115, 232, 0.3);
                  // border-bottom: none;
                  // background: rgba(0, 0, 0, 0);

                  // ****阴影***
                  // background: radial-gradient(
                  //   ellipse at center,
                  //   rgba(0, 0, 0, 0) 42%,
                  //   rgba(0, 0, 0, 0.15) 100%
                  // );
                  text-align: center;
                }
              }
            }
          }
          .newKanBan {
            // 小看板内容
            .card-contant {
              border: dashed 1px rgba(26, 115, 232, 0.8);
              height: 100% !important;
              .create-display {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                color: rgba(26, 115, 232, 0.8);
                transition: color 280ms cubic-bezier(0.4, 0, 0.2, 1);
                margin: auto !important;
                height: 68px;
                text-align: center;
                i {
                  font-size: 40px;
                  font-weight: 700;
                }
                div {
                  margin-top: 8px;
                }
              }
            }
          }

          .viewKanBan {
            position: relative;
            // 编辑名称遮罩
            .mask {
              position: absolute;
              width: 100%;
              height: 86%;
              top: 0;
              left: 0;
              z-index: 9;
            }
            //    小看板内容
            .card-contant {
              border: solid 1px rgba(26, 115, 232, 0.3);
              border-bottom: none !important;
              // 遮罩

              .card-hover-mask {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                // background-color: rgba(0, 0, 0, 0.2);
                // background: rgba(0, 0, 0, 0);
                // background: radial-gradient(
                //   ellipse at center,
                //   rgba(0, 0, 0, 0) 42%,
                //   rgba(0, 0, 0, 0.15) 100%
                // );
                transition: background 280ms cubic-bezier(0.4, 0, 0.2, 1);
              }
              .card-hover-layout {
                color: #000000;
                font-weight: bold;
                width: 100%;
                height: 40px;
                text-align: center;
                opacity: 0;
                transition: opacity 280ms cubic-bezier(0.4, 0, 0.2, 1);
                position: absolute;
                margin: auto;
                top: 0;
                bottom: 0;
                // 文本
                .card-hover-text {
                  font-size: 16px;
                  // line-height: 24px;
                  margin-bottom: 10px;
                }
                // 按钮
                .card-hover-buttons {
                  div {
                    width: 40px;
                    height: 40px;
                    font-size: 25px;
                    margin: 0 2px;
                  }
                  .el-icon-delete:hover {
                    color: red;
                  }
                }
              }
            }
            // 底部
            .card-footer {
              width: 100%;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              margin: 0;
              height: 28px;
              line-height: 28px;
              border-bottom-left-radius: 5px;
              border-bottom-right-radius: 5px;
              border: solid 1px rgba(26, 115, 232, 0.3);
              border-top: none;
              box-sizing: border-box;
              transition: border-color 280ms cubic-bezier(0.4, 0, 0.2, 1),
              box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
              position: relative;
              z-index: 1;
              // border: solid 1px rgba(26, 115, 232, 0.8);
              border-top: none;
              // 底部文字
              .card-footer-content {
                width: 100%;
                position: absolute;
                bottom: 0;
                left: 0;
                // 文本文字
                .rename-input-container {
                  display: flex;
                  padding: 0 10px;
                  text-align: left;
                  font-size: 14px;
                  color: rgba($color: #000000, $alpha: 0.6);
                  background: white;
                  // color: rgba($color: #ffffff, $alpha: 0.6) !important;
                  ::v-deep .el-input__inner {
                    padding: 0;
                  }
                  // span {
                  //   margin-right: 5px;
                  // }
                }
              }
            }
          }
        }
      }
    }
    // 分页左右按钮
    .positionPage {
      width: 150px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99;
      .positionBtn {
        cursor: pointer;
        // width: 50px;
        // height: 50px;
        // text-align: center;
        // border: 1px solid rgba(26, 115, 232, 0.8);
        border-radius: 50px;
        line-height: 50px;
        &::before {
          width: 100%;
          font-size: 50px;
          font-weight: 700;
          color: rgba($color: #000000, $alpha: 0.3);
        }
      }
      // 禁止翻页
      .activeDisabled {
        cursor: not-allowed;
      }
    }
  }
}
// 内部切换--左侧栏
::v-deep .el-tabs__nav-scroll {
  // background-color: #262c3c;
  background-color: #1f232c;

  border: 1px solid transparent;
}
// 左侧栏大框
::v-deep .el-tabs--left.el-tabs--border-card .el-tabs__header.is-left {
  border: 1px solid transparent;
}
::v-deep .el-tabs--border-card > .el-tabs__header {
  //    background-color: #262c3c;
  background-color: #1f232c;

  border: 1px solid transparent;
}
// 左侧栏选中
::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #262c3c;
  border: 1px solid transparent;
}
// 内部切换--内容
::v-deep .el-tabs--border-card {
  border: 1px solid transparent;
}
::v-deep .card-footer {
  .el-input__inner {
    border: 1px solid transparent;
    font-size: 13px;
    background: rgba($color: #eee, $alpha: 0.5);
    border-radius: 5px;
    height: 24px;
  }
}
::v-deep .shareClass {
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-card__body {
    padding: 10px 20px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 15px;
  }
  .el-form-item--small .el-form-item__error {
    padding-top: 2px;
  }
  .isHideClass {
    margin-bottom: 0px !important;
  }
  .el-input__inner {
    height: 28px;
    line-height: 28px;
  }
  .el-form-item--small .el-form-item__content,
  .el-form-item--small .el-form-item__label {
    line-height: 28px;
  }
  .el-input--small .el-input__icon {
    line-height: 28px;
  }
}
::v-deep .linkClass {
  .el-input.is-disabled .el-input__inner {
    color: #000000;
  }
}
</style>